import { createRouter, createWebHistory } from "vue-router";
import OverviewPage from "@/views/OverviewPage.vue";
import CreatePage from "@/views/CreatePage.vue";
import LyricsPage from "@/views/LyricsPage.vue";
import LibraryPage from "@/views/LibraryPage.vue";
import ReleasePage from "@/views/ReleasePage.vue";
import AnalyticsPage from "@/views/AnalyticsPage.vue";
import RevenuePage from "@/views/RevenuePage.vue";
import GrowthPage from "@/views/GrowthPage.vue";
import RightsPage from "@/views/RightsPage.vue";
import SettingsPage from "@/views/SettingsPage.vue";
import MobileUsersPage from "@/views/MobileUsersPage.vue";
import ListenPage from "@/views/ListenPage.vue";
import LoginPage from "@/views/LoginPage.vue";
import MobileCreatePage from "@/views/mobile/MobileCreatePage.vue";
import MobileListenPage from "@/views/mobile/MobileListenPage.vue";
import { api } from "@/lib/api";

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    {
      path: "/login",
      component: LoginPage,
      meta: { public: true, title: "登录声浪工坊" },
    },
    {
      path: "/",
      component: OverviewPage,
      meta: { title: "经营总览", kicker: "STUDIO PULSE" },
    },
    {
      path: "/create",
      component: CreatePage,
      meta: { title: "创作一首新歌", kicker: "MUSIC 3.0" },
    },
    {
      path: "/lyrics",
      component: LyricsPage,
      meta: { title: "歌词工作台", kicker: "LYRICS LAB" },
    },
    {
      path: "/library",
      component: LibraryPage,
      meta: { title: "作品曲库", kicker: "CATALOG" },
    },
    {
      path: "/release",
      component: ReleasePage,
      meta: { title: "发行中心", kicker: "DISTRIBUTION" },
    },
    {
      path: "/analytics",
      component: AnalyticsPage,
      meta: { title: "播放分析", kicker: "AUDIENCE SIGNAL" },
    },
    {
      path: "/revenue",
      component: RevenuePage,
      meta: { title: "收益实验室", kicker: "ROYALTY MODEL" },
    },
    {
      path: "/growth",
      component: GrowthPage,
      meta: { title: "增长任务", kicker: "GROWTH LOOPS" },
    },
    {
      path: "/rights",
      component: RightsPage,
      meta: { title: "版权与合规", kicker: "RIGHTS DESK" },
    },
    {
      path: "/mobile-users",
      component: MobileUsersPage,
      meta: { title: "申请列表", kicker: "MOBILE ACCESS" },
    },
    {
      path: "/settings",
      component: SettingsPage,
      meta: { title: "工作室设置", kicker: "CONTROL ROOM" },
    },
    {
      path: "/listen/:id",
      component: ListenPage,
      meta: { public: true },
    },
    {
      path: "/m",
      alias: "/m/create",
      component: MobileCreatePage,
      meta: { public: true, title: "AI 音乐创作", kicker: "MOBILE STUDIO" },
    },
    {
      path: "/m/listen/:id",
      component: MobileListenPage,
      meta: { public: true },
    },
  ],
});

router.beforeEach(async (to) => {
  if (to.path === "/login") {
    try {
      if ((await api.session()).authenticated) return "/";
    } catch {
      // 登录页仍应在服务短暂不可用时正常展示错误状态。
    }
    return true;
  }
  if (to.meta.public) return true;
  try {
    if ((await api.session()).authenticated) return true;
  } catch {
    // 会话读取失败按未登录处理。
  }
  return { path: "/login", query: { redirect: to.fullPath } };
});

export default router;
